import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Card from "../components/ui/Card";
import { useAppDispatch, useAppSelector } from "../app/hooks";
import { searchFipThunk } from "../features/fip/fipThunk";

const DiscoveryLoader: React.FC = () => {
    const navigate = useNavigate();
    const dispatch = useAppDispatch();

    const { selectedCategoryId } = useAppSelector((state) => state.fip);

    useEffect(() => {
        // Initiate the actual API calls for FIP discovery in the background
        // Asset class is now dynamic based on user selection
        dispatch(searchFipThunk({ assetClassId: selectedCategoryId || "BANK" }));

        // Simulate a minimum loader time so the user can read the security message
        const timer = setTimeout(() => {
            navigate("/userBank");
        }, 3000);

        return () => clearTimeout(timer);
    }, [dispatch, navigate, selectedCategoryId]);

    return (
        <div className="flex flex-col items-center justify-center min-h-screen p-4 bg-fin-bg">
            <div className="w-full max-w-sm flex flex-col items-center">

                {/* Spinner */}
                <div className="relative w-20 h-20 mb-8">
                    <div className="absolute inset-0 rounded-full border-4 border-fin-surface"></div>
                    <div className="absolute inset-0 rounded-full border-4 border-fin-primary border-t-transparent animate-spin"></div>
                    <div className="absolute inset-0 flex items-center justify-center">
                        <svg className="w-8 h-8 text-fin-primary animate-pulse" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
                        </svg>
                    </div>
                </div>

                <div className="text-center mb-10 w-full px-4">
                    <h2 className="text-xl font-bold text-white leading-snug">
                        Finding accounts linked to your mobile number
                    </h2>
                    <p className="text-sm text-fin-slate mt-2">
                        Please wait while we securely discover your financial institutions.
                    </p>
                </div>

                {/* Security Card */}
                <Card className="w-full bg-fin-surface border-fin-border shadow-none flex items-start p-4 backdrop-blur-sm">
                    <div className="h-10 w-10 rounded-full bg-fin-primary/10 flex items-center justify-center flex-shrink-0 mr-4 border border-fin-primary/20">
                        <svg className="h-5 w-5 text-fin-primary" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z" />
                        </svg>
                    </div>
                    <div>
                        <h3 className="font-bold text-white text-sm">Your data is safe and secure</h3>
                        <p className="text-xs text-fin-slate mt-1 leading-relaxed">
                            We are discovering accounts and we don't have access to your data.
                        </p>
                    </div>
                </Card>
            </div>
        </div>
    );
};

export default DiscoveryLoader;
